import { GeneralModel } from "./general.model";

export class ListReceiptMoneyType extends  GeneralModel {  
}